module.exports = __webpack_public_path__ + "static/media/img29.7023164d.jpg";